<template>
    <div class="container">
        <div>
            <h1>Testimonials</h1>
        </div>
        <div class="flex-wrapper">
            <div class="left">
                <p>
                     <img src="https://xperienceeducation-assets.s3.amazonaws.com/home/Randall-image.png" alt="Profile Image">
                </p>
                <p style="font-weight: 600; margin:0; padding:0; font-size: 1.1rem;">
                    Randall Dennis
                </p>
                <p style="font-weight: 600; margin:0; font-size: .9rem; color: #787878;">
                    Randa Solutions
                </p>
                <p>
                    "DEEP is the ideal way to understand how online your district is, and gives a detailed analysis tied to national standards. Because it's based on a validated, research-based framework, I know I can be confident in the results."
                </p>
            </div>
            <div class="right">
                <p>
                     <img src="https://xperienceeducation-assets.s3.amazonaws.com/home/Chapman-image.png" alt="Profile Image">
                </p>
                 <p style="font-weight: 600; margin:0; padding:0; font-size: 1.1rem;">
                    Tai Chapman
                </p>
                <p style="font-weight: 600; margin:0; font-size: .9rem; color: #787878;">
                    NASBE
                </p>
                <p>
                    "With mastery of core development skills and accountability being in the forefront of determining proficiencies, I was delighted to see educators could create a personalized development plan based on competences. The process isn't intimidating- so you can focus on reviewing best practices around the globe."
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    "name": "header-section-6",
    setup() {
        
    },
}
</script>

<style lang="scss" scoped>
@import '@/styles/shared.scss';

.container{
    margin-bottom: 100px;
    h1{
        font-size: 2rem;
        color: #662d91;
        
    }
}

.flex-wrapper{
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;

    @media(min-width: $bp-tablet-portrait){
        flex-wrap: nowrap;
        margin-left: 5%; 
        margin-right: 5%; 
    }

    .left{
        flex: 100%;
    }

    .right{
        flex: 100%;
    }

}


</style>